// src/services/addressName.ts
// ---------------------------
// The delivery-address NAME rule (David, 25 Oct 2026). The name is not just a
// portal label: it becomes the Sales Order's Delivery Name in Unleashed
// (salesOrderCreation / topUpSalesOrderCreation → delivery_name), so it prints on
// the delivery. Rule:
//   • open address         → the organisation's name
//   • confidential address → "Att:" followed by the primary contact / caseworker
// A blank name is REFUSED on every entry screen — it is no longer auto-filled as
// "Delivery N" / "Default Delivery" (those would print on the delivery).
// Wording lives here only; AddressNameHelp.jsx renders the help text.
// (The CSV importer is untouched — its column comes from the Unleashed export.)

export const ADDRESS_NAME_PLACEHOLDER = "e.g. Example Women's Service, or Att: Jane Citizen";

export const ADDRESS_NAME_HELP_TEXT =
  "Prints on the delivery. Open address: the organisation's name. Confidential address: \"Att:\" then the primary contact or caseworker's name.";

export const ADDRESS_NAME_REQUIRED_MSG =
  "Enter a name: the organisation's name, or \"Att:\" and the contact's name.";

export function isBlankAddressName(name: string | null | undefined): boolean {
  return String(name ?? "").trim() === "";
}
